import React, { Component } from 'react';
import { Row, Col } from 'antd';
import './index.css'
import '../../assets/css/common.css'
import { searchAPI } from '../../api/team.js'
import MyBreadcrumb from '../../components/MyBreadcrumb.jsx'

class Team extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dataSourceTeacher: [],
			dataSourceStudent: [],
		};
	}

	componentDidMount() {
		this.ajaxData()
	}

	// 获取表格数据
	ajaxData = () => {
		searchAPI({ group: '师资力量' })
			.then(res => {
				console.log('ajax', res.data.data.data);
				this.setState({ dataSourceTeacher: res.data.data.data })
			})

		searchAPI({ group: '学生' })
			.then(res => {
				console.log('ajax', res.data.data.data);
				this.setState({ dataSourceStudent: res.data.data.data })
			})
	}
	render() {
		const { dataSourceTeacher, dataSourceStudent } = this.state;
		return (
			<div style={{ margin: '40px 15%', }}>
				<MyBreadcrumb urls={[
					{ url: '/team', breadcrumbName: '团队' },
				]} />
				{/* 师资力量 */}
				<div className="major-heading module-title" style={{ textAlign: 'left', color: '#144db9' }}>师资力量</div>
				<div className="auxiliary-text module-subtitle">FACULTY</div>

				<Row className="img-team" style={{ marginTop: 20 }} gutter={12}>
					{dataSourceTeacher.map((item, index) =>
						<Col key={index} span={8} >
							<a target="_blank" href={item.url}>
								<div className="faculty-card">
									<img src={item.photo} alt='' style={{ float: 'left' }} />
									<div className="faculty-name minor-heading">{item.name} <span className="faculty-position auxiliary-text">{item.title}</span></div>
									<div className="faculty-des main-text">{item.profile}</div>
								</div>
							</a>
						</Col>
					)}
				</Row>

				{/* 学生 */}
				<div className="major-heading module-title" style={{ textAlign: 'left', marginTop: 60, color: '#144db9' }}>团队成员</div>
				<div className="auxiliary-text module-subtitle">STUDENTS</div>

				<Row className="img-team" style={{ marginTop: 10 }}>
					{dataSourceStudent.map((item, index) =>
						<div key={index} className="stu-block">
							<div className="name minor-heading">{item.name}</div>
							<div className="grade main-text">{item.title}</div>
							<div className="description auxiliary-text">{item.profile}</div>
						</div>
					)}
				</Row>
			</div>
		);
	}
}

export default Team
